import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import LoadingSpinner from '../loadingSpinner/';
import { getQueryVariable } from '../../common';
import Message from '../message';

@inject('accountStore', 'dictStore', 'appStore')
@observer
export default class Logout extends Component{

  state = {
    currentCount: 10
  }

  intervalId = null;

  componentDidMount() {
    this.props.appStore.toggleShowTopMenu(false);
    this.intervalId = setInterval(this.timer, 1000);
  }

  componentWillUnmount(){
    this.props.appStore.toggleShowTopMenu(true);
    clearInterval(this.countdown);
  }

  timer = () => {
    let newCount = this.state.currentCount - 1;
    if(newCount >= 0) { 
       this.setState({ currentCount: newCount });
    } else {
       this.logout();
    }
  }

  logout = () => {
    this.props.accountStore.logout();
  }

  render() {
    const {logout_hash} = this.props.accountStore;
    const {getLang} = this.props.dictStore;
    return(
      <Fragment>
        <div className="logout-delayed">
          <div className="logout-delayed-img-cont">
            <LoadingSpinner />
          </div>
          <div className="logout-delayed-text-cont">
              <p>
                  {getLang('LOGIN_DELAYED_TEXT_1')}
              </p>
              <p>
                  {getLang('LOGIN_DELAYED_TEXT_2')}
              </p>
              <p>
                  {getLang('VIA')} <span>{this.state.currentCount}</span> {getLang('LOGIN_DELAYED_TEXT_3')}
              </p>
          </div>
          <div className="logout-delayed-button-cont">
              <button onClick={this.logout} type="button" className="flat_button flat_button_big">{getLang('EXIT')}</button>
          </div>
        </div>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/login/logout.jsx